import { HttpClient, HttpEvent, HttpEventType, HttpRequest } from '@angular/common/http';
import { Observable, filter, map } from 'rxjs';

export interface UploadProgressEvent<T> {
  type: 'progress' | 'response';
  /** 0–100 durante o upload; 100 na resposta final. */
  progress: number;
  body?: T;
}

/**
 * POST multipart com reportProgress, emitindo % e a resposta tipada no fim.
 */
export function postWithUploadProgress<T>(
  http: HttpClient,
  url: string,
  body: FormData
): Observable<UploadProgressEvent<T>> {
  const req = new HttpRequest('POST', url, body, {
    reportProgress: true,
  });

  return http.request<T>(req).pipe(
    filter(
      (event: HttpEvent<T>): boolean =>
        event.type === HttpEventType.UploadProgress || event.type === HttpEventType.Response
    ),
    map((event): UploadProgressEvent<T> => {
      if (event.type === HttpEventType.UploadProgress) {
        const total = event.total && event.total > 0 ? event.total : 0;
        const progress = total ? Math.min(99, Math.round((100 * event.loaded) / total)) : 0;
        return { type: 'progress', progress };
      }
      return {
        type: 'response',
        progress: 100,
        body: (event as { body: T | null }).body as T,
      };
    })
  );
}
